import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Mir = function Mir(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Mir_svg__Mir_svg__clip0_20336_109076)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Mir_svg__a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 15,
    width: 11,
    height: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.093 15.08c.013.255.05.504.106.745.014.054.026.108.041.16l.019.066a4.263 4.263 0 004.064 2.979h5.629a3.35 3.35 0 00.056-.594c0-.98-.422-1.858-1.091-2.472a3.343 3.343 0 00-2.265-.884h-6.56z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mir_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.117 34.79h58.16V8.344h-58.16v26.444z",
    fill: "url(#Mir_svg__Mir_svg__paint0_linear_20336_109076)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.234 19.607v5h3.048v-2.815h3.069c1.602 0 2.97-.91 3.498-2.185h-9.615zm-5.404-3.52l-2.133 4.624h-.217v-5.63h-3.032v9.528h2.573c.676 0 1.29-.393 1.573-1.007l2.134-4.623h.217v5.63h3.032V15.08h-2.573c-.676 0-1.29.393-1.573 1.007zm-14.117.246l1.263 4.378h.217l1.263-4.378a1.733 1.733 0 011.664-1.253h3.029v9.529h-3.032v-5.63H11.9l-1.733 5.63H8.002l-1.733-5.63h-.216v5.63H3.02V15.08h3.028c.771 0 1.45.511 1.664 1.253z",
    fill: "#064"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Mir_svg__Mir_svg__paint0_linear_20336_109076",
    x1: 27.093,
    y1: 17.055,
    x2: 37.008,
    y2: 17.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3E91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Mir_svg__Mir_svg__clip0_20336_109076"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3 14.5)",
    d: "M0 0h34v10.845H0z"
  }))));
};
export default Mir;